import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { UserStore } from '../../stores/user.store';

@Component({
  selector: 'app-admin-page',
  template: `
    <div class="container py-gutter">
    ADMIN

    </div>

  `,
  styles: [
  ],
  animations: [
  ]
})
export class AdminComponent implements OnInit {

  constructor(
    private userStore: UserStore,
    private sanitizer: DomSanitizer
  ) { }

  async ngOnInit() {
  }

}
